<template>
    <div class="d-flex justify-center fill-height page">
        <v-container class="d-flex align-center justify-center flex-column mx-6">
            
            <transition :name="codeSent ? 'slide-left' : 'slide-right'" mode="out-in">
                <v-card v-if="!codeSent && !tokenReceived" class="form-wrapper soft-shadow pb-8" :key="2">
                    <v-form @submit.prevent="sendCode">
                        <v-card-title class="justify-center mb-3">استعادة كلمة المرور</v-card-title>
                        <v-card-subtitle class="grey--text details-text text-center mb-7 mx-4">سنسرسل إلى البريد الإلكتروني الخاص بك رمز، ستتمكن من خلاله انشاء كلمة مرور جديدة</v-card-subtitle>
                        <v-text-field placeholder="أدخل البريد اﻹلكتروني المرتبط بحسابك" label="البريد الإلكتروني" name="email" v-model="email" ref="emailInput" :loading="loading" :disabled="loading" outlined hide-details></v-text-field>
                        <v-btn type="submit" block depressed large :disabled="loading || !email" :loading="loading" color="primary" class="mt-5" @click.prevent="sendCode">إرسال الرمز</v-btn>
                    </v-form>
                </v-card>

                <v-card v-else-if="codeSent && !tokenReceived" class="form-wrapper soft-shadow pb-8" :key="1">
                    <v-form ref="codeForm" @submit.prevent="validateCodeAction">
                        
                        <v-card-title class="justify-center mb-3">أدخل الرمز</v-card-title>
                        <v-card-subtitle class="grey--text details-text text-center mb-7 mx-4">أرسلنا إليك رمز مكون من 4 أرقام في رسالة إلى بريدك الإلكتروني، أدخل الرمز هنا</v-card-subtitle>
                        
                        <digits-input :loading="loading" :auto-focus="true" v-model="code" />
                        <v-btn type="submit" block depressed large :disabled="!code || code.length !== 4 || loading || !email" :loading="loading" color="primary" class="mt-4" @click.prevent="validateCodeAction">التحقق من الرمز</v-btn>
                    </v-form>
                </v-card>
                
                <v-card v-else class="form-wrapper soft-shadow pb-8" :key="3">
                    <v-form ref="passwordForm" @submit.prevent="newPassword">
                        <v-card-title class="justify-center font-weight-bold primary--text mb-3">أدخل كلمة المرور الجديدة</v-card-title>
                        <v-card-subtitle class="grey--text details-text text-center mb-7 mx-4">أدخل كلمة سر جديدة حتى تتمكن من الدخول لحسابك بها.</v-card-subtitle>
                        <v-text-field outlined placeholder="أدخل كلمة المرور الجديدة" label="كلمة المرور"  name="password" v-model="password" :loading="loading" :disabled="loading" :rules="[rules.global.required, ...rules.password]" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field>
                        <v-text-field outlined placeholder="تأكيد كلمة المرور الجديدة" label="تأكيد كلمة المرور"  name="confirm_password" :loading="loading" :disabled="loading" :rules="[rules.global.required, ...rules.confirmPassword]" v-model="confirmPassword" :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showConfirmPassword ? 'text' : 'password'" @click:append="showConfirmPassword = !showConfirmPassword"></v-text-field>
                        <v-btn type="submit" block depressed large :disabled="loading || !email" :loading="loading" color="primary" class="mt-2" @click.prevent="newPassword">تغيير كلمة المرور</v-btn>
                    </v-form>
                </v-card>

            </transition>

            <div class="footer mt-auto mt-md-9 mx-auto py-3">
                <v-btn v-if="!tokenReceived" text :disabled="loading" large @click="codeSent ? codeSent = false : goBack()">
                    {{codeSent ? 'إرسال مرة أخرى' : 'الرجوع للخلف'}}
                    <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>

// @ is an alias to /src
import digitsInput from '../components/default/digits-input'
export default {
    name: 'resetPassword',
    data(){
        return {
            email: '',
            loading: false,
            codeSent: false,
            tokenReceived: false,
            code: '',

            password: '',
            confirmPassword: '',
            resetPasswordUrl: '',

            showPassword: false,
            showConfirmPassword: false,
            rules: {
                global: {
                    required: value => !!value || 'لا يمكنك ترك الحقل فارغاً'
                },
                email: [
                    value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || 'البريد الإلكتروني غير صحيح';
                    }
                ],
                password: [
                    value => value.length >= 6 || "يجب أن لا يقل عدد الحروف عن 6"
                ],
                confirmPassword: [
                    value => value === this.password || 'كلمتا المرور غير متطابقتين'
                ]
            },

        };
    },
    components: {
        digitsInput
    },
    computed:{
        appLoadedOnce(){
            return this.$store.state.loaded;
        },
    },
    methods: {
        sendCode(){
            const self = this;
            let email = this.email;
                
            if (email){
                let validateResponse = this.rules.email[0](email);
                if ( validateResponse === true){

                    this.loading = true;
                    
                    this.$store.dispatch('sendCodeAction', {email}).then(()=>{
                        this.showMsg("تم إرسال الرمز إلى البريدك الإلكتروني بنجاح", 'success', 2000);
                        this.codeSent = true;
                        this.loading = false;
    
                    }).catch(error=>{

                        // handle errors, ex: user has no email in their account .. etc
                        if (error.response && error.response.status === 404){
                            this.showMsg("البريد الإلكتروني الذي أدخلته غير مرتبط بأي حساب");
                        }else if (error.response.status === 422){
                            this.showMsg("البريد الإلكتروني غير صحيح");
                        }else if (error.response.data.message === 'CANNOT_RESET_ADMIN_ACCOUNT'){
                            this.showMsg("لا تحاول استعادة كلمة مرور حساب اﻷدمن");
                        }else{
                            this.showMsg("حدثت مشكلة أثناء إرسال الرمز، حاول لاحقاً");
                        }
                        
                        this.loading = false;
                        setTimeout(()=>{
                            self.$refs.emailInput.focus();
                        }, 150);
                    })
                    
                }else{
                    this.showMsg(validateResponse);
                    setTimeout(()=>{
                        self.$refs.emailInput.focus();
                    }, 150);
                }

            }else{
                this.showMsg("أدخل البريد الإلكتروني الخاص بحسابك");
                setTimeout(()=>{
                    self.$refs.emailInput.focus();
                }, 150);
            }
        },
        validateCodeAction(){
            // const self = this;
            let email = this.email,
                code = this.code,
                pattern = /^[0-9]{4}$/g;
            // check if reponse if parseInt for code is int, and length = 4
            if (code && pattern.test(code.toString())){
                
                this.loading = true;
                this.$store.dispatch('validateCodeAction', {email, code}).then(response=>{

                    if (response.data.resetUrl){
                        this.resetPasswordUrl = response.data.resetUrl;
                        this.tokenReceived = true;
                        this.loading = false;
                    }else{
                        this.showMsg("حدثت مشكلة أثناء فحص الرمز، حاول لاحقاً - 2");
                    }

                }).catch(error=>{
                    // this.$refs.codeForm.reset();
                    // handle errors, ex: user has no email in their account .. etc
                    if (error.response){
                        if (error.response.data.msg === 'EXPIRED_CODE'){
                            this.showMsg("انتهت المدة المسموح بها للرمز الذي أدخلته");
                        }else if (error.response.data.msg === 'INVALID_CODE'){
                            this.showMsg("الرمز الذي أدخلته غير صحيح");
                        }else{
                            this.showMsg("حدثت مشكلة أثناء فحص الرمز، حاول لاحقاً");
                        }
                    }else{
                        this.showMsg("حدثت مشكلة أثناء فحص الرمز، حاول لاحقاً");
                    }
                    this.loading = false;
                })
                
            }else{
                this.showMsg("أدخل الرمز بشكل صحيح (مكون من 4 أرقام)");
            }
        },
        newPassword(){
            let password = this.password,
                url = this.resetPasswordUrl;
            if (this.$refs.passwordForm.validate()){
                
                this.loading = true;
                this.$store.dispatch('newPasswordAction', {password, url}).then(()=>{

                    this.loading = false;
                    this.showMsg("تم تغيير كلمة المرور بنجاح، يمكنك تسجيل الدخول الآن", 'success', 2000);
                    window.setTimeout(()=>{
                        this.$router.push({name: 'login'});
                    }, 1000);

                }).catch(()=>{

                    // handle errors, ex: user has no email in their account .. etc
                    this.showMsg("حدثت مشكلة ، ربما قد انتهى وقت صلاحية الرمز");
                    
                    this.loading = false;
                })

            }else{
                this.showMsg("أدخل كلمة المرور بشكل صحيح");
            }
        },
        updateCode(code){
            this.code = code;
        },
        showMsg(text, color = 'error', timeout = 4000){
            this.$store.dispatch('addSnackMsg', {show: true, text: text, color: color, timeout: timeout, msgBar: true});
        },
        closeMsg(){
            if (this.$store.state.globalModule.snackMsg.text){
                this.$store.dispatch('addSnackMsg', {show: false, text: '', msgBar: true});
            }
        },
        goBack(){
            this.$router.go(-1);
            // this.$router.push({path: '/'});
        },
    },
    watch: {
        email(){
            this.closeMsg();
        },
        password(){
            this.closeMsg();
        },
        codeSent(sent){
            if (!sent){
                // this.$refs.codeForm.reset();
            }
        },
        code(){
            // this.closeMsg();
        }
    },
}
</script>

<style lang="scss" scoped>
    .logo-wrapper{
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .logo{
            max-width: 150px;
            min-width: 120px;
            height: auto;
        }
    }
</style>